import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appHorizontalScrollwheel]'
})
export class HorizontalScrollwheelDirective {

  /** Al hacer scroll horizontal usando la tecla shift, el scroll es muy lento, usamos esta
   directiva para tomar el scrollwheel y en lugar de que se aplique directamente, lo aplicamos con un valor incrementado
   finalmente disparamos el evento de scroll para que las piezas de codigo que esperan este evento se disparen **/

  constructor(private element: ElementRef) {}

  @HostListener('mousewheel', ['$event']) onMousewheel(event) {
    // solo tomamos el evento en caso de que sea scroll horizontal, es decir con la tecla shift
    if (event.shiftKey) {
      // aplicamos el scroll
      this.element.nativeElement.scrollLeft += event.deltaY;
      // evitamos que se dispare el evento de scroll
      event.preventDefault();
      // disparamos el evento de scroll en el elemento
      this.element.nativeElement.dispatchEvent(new CustomEvent('scroll'));
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/horizontal-scrollwheel-directive.ts